import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';

type SWGatewayDeviceRegistrationEndpointSpecification = ApiEndpointSpecification;
export const SWGatewayDeviceRegistrationEndpointSpecification: SWGatewayDeviceRegistrationEndpointSpecification = {
    url: '/api/sierradevice/register/gateway',
    method: HttpMethod.POST,
    requestParamsSchemaName: 'SwGatewayDeviceRegistrationRequestParams',
    requestBodySchemaName: 'SwGatewayDeviceRegistrationRequestBody',
    okResponseSchemaName: 'SwGatewayDeviceRegistrationOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeSWGatewayDeviceRegistration = Helpers.makeApiRequestFn<
    Types.SWGatewayDeviceRegistrationRequestParams,
    Types.SWGatewayDeviceRegistrationRequestBody,
    Types.SWGatewayDeviceRegistrationOkResponse
>(SWGatewayDeviceRegistrationEndpointSpecification);
